import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'unit',
    serviceName: 'graphql',
    query: gql`
      query unit($ids: [String]) {
        unit(ids: $ids) {
          data {
            id
            title
            media {
              id
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
